'use client';
import { useEmbeddedWalletMigration } from '@/hooks';

/**
 * Null-rendering global component that polls the Privy embedded wallet
 * every 30 seconds and forwards any USDC.e / native USDC to the proxy
 * wallet so funds become available for Polymarket CLOB trading.
 *
 * This is needed because Privy's fundWallet always deposits into the
 * embedded wallet, and exchange/card deposits can take 5–30 minutes to
 * arrive on-chain — well after the Privy modal has already closed.
 */
export function EmbeddedWalletMigrator() {
  useEmbeddedWalletMigration();
  return null;
}
